import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RightEnum } from '../models/enums/right.enum';
import { EntityType } from './transport-order-extended.service';
import { ApiProviderService } from './api-provider.service';

@Injectable({ providedIn: 'root' })
export class BaryRightService {
  private resourceUrl: string = '/moderators/right';
  public customerIdsChangeRight: Set<number> = new Set<number>();

  constructor(protected apiProvider: ApiProviderService, protected http: HttpClient) {}

  public updateRight(right: RightEnum, customerIds: Set<number>): Observable<any> {
    return this.apiProvider.put<EntityType>(`${this.resourceUrl}`, {
      customersIds: Array.from(customerIds),
      right,
    });
  }
}
